/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
} from "@mineral/core";
import { selectMetricType } from "../../api/metricTypes/actions";

class MetricListItem extends Component {
  handleChange(metricType, id, event) {
    let selected = event.target.checked;
    let selectedState = selected === this.props.selected ? !selected : selected;
    this.props.onCheck(metricType, id, selectedState);
  }

  render() {
    const { primaryText, secondaryText, selected, metricType, id } = this.props;

    const checkbox = (
      <Checkbox
        style={{ left: "24px" }}
        iconStyle={!selected ? { fill: "#C9C9C9" } : null}
        defaultChecked={selected}
        onChange={(event) => this.handleChange(metricType, id, event)}
        aria-labelledby={primaryText}
      />
    );

    let style = {
      color: "#fff",
      backgroundColor: selected ? "#4D4D4D" : null,
    };
    return (
      <ListItem
        style={style}
        key={id}
        //secondaryTextLines={2}
      >
        <ListItemIcon>{checkbox}</ListItemIcon>
        <ListItemText
          primary={primaryText}
          id={primaryText}
          secondary={secondaryText}
        />
      </ListItem>
    );
  }
}

const mapStateToProps = (state, props) => {
  const metricType = state.types.items[props.metricId];
  return {
    metricType: metricType.metricType,
    id: metricType.id,
    primaryText: props.child
      ? metricType.ciName
      : metricType.name && metricType.name !== "null"
      ? metricType.name
      : metricType.qosName,
    secondaryText: props.child
      ? null
      : `${metricType.description}, ${metricType.unit}`,
    selected: metricType.selected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCheck: (metricTypeId, metricId, selected) =>
      dispatch(selectMetricType(metricTypeId, metricId, selected)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MetricListItem);
